import React , {useState, useEffect} from 'react';
import {vipTokenString, vvipTokenString, siteUrl, loginSuccess, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../constants/global';
import Loginlogo from '../assets/images/login-logo.png';
import { useSelector, useDispatch } from 'react-redux';
import {useNavigate, useLocation, Outlet, NavLink} from "react-router-dom";
import allActions from '../actions/index';
import LoginRightBottom from './sub-components/LoginRightBottom';
import Copyright from './sub-components/Copyright';
import Logout from './common/Logout';



const Login = () => {

        const queryParams = new URLSearchParams(window.location.search)
        const queryEmail = queryParams.get("email");
        const vipToken = queryParams.get("token");

       /******Use for redirection after login******/
       const navigate = useNavigate();
       const location = useLocation();

         /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

       let rememberLogin = localStorage.getItem('communityremember');
       let storageData = rememberLogin ? JSON.parse(rememberLogin) : "";
       var initialUsername = storageData ? storageData.user_email :  "";
       
       /********if in query string have email id for first time login**********/
       if(queryEmail){
            initialUsername = queryEmail;
       }

       var initialPassword = "";
       if(vipToken===vipTokenString){
            initialUsername = "vip@ciisummit.com";
            initialPassword = "vipaccess@123!";
       }

        /******input variables******/
       const [username, setUsername] = useState(initialUsername);
       const [password, setPassword] = useState(initialPassword);
       const [newpassword, setNewPassword] = useState("");
       const [confirmpassword, setConfirmPassword] = useState("");
       const [otp, setOtp] = useState("");
       const [rememberme, setRememberMe] = useState(storageData ? storageData.remember_me :  "");
       
       /******screen show variables*****/
       const [loginscreen, setLoginScreen] = useState(queryEmail ? false : true);
       const [forgetscreen, setForgetScreen] = useState(queryEmail ? true : false);
       const [passwordscreen, setPasswordScreen] = useState(false);
       const [otpscreen, setOtpScreen] = useState(false);
       
       /*******message show response variable******/
       const [loading,setLoading] = useState(false);
       const [isAnonymous,setIsAnonymous] = useState(true);
       const [butttontext,setButtonText] = useState(true);
       const [responsemessage, setResponseMessage] = useState("");
       
       const LoginLogout = useSelector(state => state.LoginLogout);
       const dispatch = useDispatch();
   

       useEffect(() => {
               /*******If VIP token matched then direct login submit*******/
                if(vipToken===vipTokenString){
                     callLoginSubmit();
                }
       },[]);

    
        function WelcomeCloseModal(e) {
        var x = document.getElementById("welcome_modal");
        x.style.display = "none";
        }

        /*********For input fields*********/
       function handleInputChange(e){
          if(e.target.name==='username'){
            setUsername(e.target.value);
          }
          if(e.target.name==='password'){
            setPassword(e.target.value);
          }
          if(e.target.name==='newpassword'){
            setNewPassword(e.target.value);
            setIsAnonymous(true);
            var hasNumber = /\d/;   
            var alphabets = /([a-zA-Z])/;
            var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
            if(e.target.value.length<6){
                setResponseMessage({status:'error',message:passwordWeak});
            }else if(hasNumber.test(e.target.value) && special_characters.test(e.target.value) && alphabets.test(e.target.value)){
                setResponseMessage("");
                setIsAnonymous(false);
            }else{
                setResponseMessage({status:'error',message:passwordMedium});
            }
          }
          if(e.target.name==='confirmpassword'){
            setConfirmPassword(e.target.value);
          }
          if(e.target.name==='otpconfirm'){
            setOtp(e.target.value);
          }
       }

       /*******For checkbox is check or not******/
       function handleChechbox(e){
            setRememberMe(e.target.checked);
       }
   
       /******Login Entry in database******/
       function callLoginEntry(){
        var storageCiisummit = localStorage.getItem('_ciisummit');
        var myHeaders = new Headers();
        var formdata = new FormData();
        formdata.append("username", username);
        formdata.append("cookie_id", storageCiisummit);
        formdata.append("user_agent", window.navigator.userAgent);

        var requestOptionsLogin = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };

        return fetch(siteUrl+'/community-rest-functions.php?action=login_entry',requestOptionsLogin);
       }


       const callLoginSubmit = () => {
                /******username and password not empty*****/
                if(username && password){
                setLoading(true);
                /********if remember me true then set in localstorage*******/
                if(rememberme==true){ 
                    let rememberMeData = {
                        user_email : username,
                        remember_me  : true,
                        };
                    var rememberMeObj = JSON.stringify(rememberMeData);
                    localStorage.setItem('communityremember', rememberMeObj);
                    }else{
                    localStorage.setItem('communityremember', "");
                    }
    
                var myHeaders = new Headers();
                var formdata = new FormData();
                formdata.append("username", username);
                formdata.append("password", password);
        
                var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
                };
        
                /********calling fetch method to check user and get token***********/
                fetch(siteUrl+'/wp-json/jwt-auth/v1/token',requestOptions)
                .then((response) => response.json())
                .then(function(actualData){ 
                    setLoading(false);
                    /******valid details and got token******/
                    if(actualData.token){
                        setResponseMessage({status:"success",message:loginSuccess});

                        actualData.login = true;
            
                        /******set token object in localstorage and state*******/
                        var requestObject = JSON.stringify(actualData);
                        localStorage.setItem('authlogin', requestObject);
                        dispatch(allActions.LoginLogoutActions.logIn(actualData));
                        dispatch( allActions.ModalPopup.hidePopup(""));

                        /*******navigate to referral URL ********/
                        if(!location.state){
                            /*****if user coming from login refereal then redirect to home page********/
                            navigate('/');
                        }else{
                            /*********User redirect to refereal page********/
                            navigate(location.state.from);
                        }

                        /*******call login entry********/
                        callLoginEntry();
                        
                    }else if(actualData.code==='[jwt_auth] invalid_username' || actualData.code==='[jwt_auth] invalid_email'){
                        setResponseMessage({status:"error",message:invalidUsername});
                    }else if(actualData.code==='[jwt_auth] incorrect_password'){
                        setResponseMessage({status:"error",message:invalidPassword});
                    }
                }).catch(rejected => {
                    setLoading(false);
                    setResponseMessage({status:"error",message:highTrafficLogin});
                });

            }
       }
       
       /******Direct Login button click*******/
       const loginSubmit = (event) => {
           event.preventDefault();
           setResponseMessage("");

            callLoginSubmit();
             
       }

       /********Forget form submit*******/
       const forgetSubmit = (event) => {
            event.preventDefault();
            setResponseMessage("");
            setLoading(true);

            var myHeaders = new Headers();
            var formdata = new FormData();
            formdata.append("username", username);

            var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
            };

            /********calling fetch method to check user and get token***********/
            fetch(siteUrl+'/community-rest-functions.php?action=email_check',requestOptions)
            .then((response) => response.json())
            .then(function(actualData){ 
                setLoading(false);
                if(actualData.status==='success'){
                    setForgetScreen(false);
                    setPasswordScreen(true);
                }else if(actualData.status==='error'){
                    setResponseMessage({status:"error",message:actualData.message});
                }
            }).catch(rejected => {
                setLoading(false);
                setResponseMessage({status:"error",message:highTrafficLogin});
            });
       }

       /*********send Notification to user*********/
       const sendNotificationToUser = (fromData) => {
            setResponseMessage("");
            console.log(fromData);
                
            /******If password and confirm password matched********/
            if(newpassword===confirmpassword && newpassword && confirmpassword){
               
                if(fromData==='setPassword'){
                    setLoading(true);
                }

                var myHeaders = new Headers();
                var formdata = new FormData();
                formdata.append("username", username);
                formdata.append("newpassword", newpassword);

                var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
                };
                setResponseMessage({status:"success",message:"Sending OTP ..."});
                /********calling fetch method to check user and get token***********/
                fetch(siteUrl+'/community-rest-functions.php?action=send_notification',requestOptions)
                .then((response) => response.json())
                .then(function(actualData){ 
                    setButtonText(true);
                    setLoading(false);
                    setPasswordScreen(false);
                    setOtpScreen(true);
                    if(actualData.status==='success'){
                        setResponseMessage({status:"success",message:actualData.message});
                    }else if(actualData.status==='error'){
                        setResponseMessage({status:"error",message:actualData.message});

                    }
                }).catch(rejected => {
                    setLoading(false);
                    setResponseMessage({status:"error",message:highTrafficLogin});
                });
            }else{
                setResponseMessage({status:"error",message:confirPasswordNotMatched});
            }
       }

       /********Set password click********/
       const setPasswordSubmit = (event) => {
            event.preventDefault();
            sendNotificationToUser('setPassword');
       }

       /*******click on resend OTP if they did not get*********/
       const resendOTP = () => {
            setButtonText(false);
            sendNotificationToUser('resendOTP');
        }

       /******Submit OTP******/
       const setOtpSubmit = (event) => {
            event.preventDefault();
            setResponseMessage("");
            
            if(otp){
                setLoading(true);

                var myHeaders = new Headers();
                var formdata = new FormData();
                formdata.append("username", username);
                formdata.append("newpassword", newpassword);
                formdata.append("otp", otp);
    
                var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
                };
    
                /********calling fetch method to check user and get token***********/
                fetch(siteUrl+'/community-rest-functions.php?action=check_otp_and_login',requestOptions)
                .then((response) => response.json())
                .then(function(actualData){ 
                    setLoading(false);
                    if(actualData.status==='success'){
                        setResponseMessage({status:"success",message:actualData.message});
                        loginTriggerSubmit();
                    }else if(actualData.status==='error'){
                        setResponseMessage({status:"error",message:actualData.message});
                    }
                }).catch(rejected => {
                    setLoading(false);
                    setResponseMessage({status:"error",message:highTrafficLogin});
                });
            }
       }


        /******Login Trigger if otp confirmed*******/
        const loginTriggerSubmit = () => {

        /******username and password not empty*****/
            if(username && newpassword){

                /********if remember me true then set in localstorage*******/
                if(rememberme==true){ 
                    let rememberMeData = {
                        user_email : username,
                        remember_me  : true,
                    };
                    var rememberMeObj = JSON.stringify(rememberMeData);
                    localStorage.setItem('communityremember', rememberMeObj);
                }else{
                    localStorage.setItem('communityremember', "");
                }

                var myHeaders = new Headers();
                var formdata = new FormData();
                formdata.append("username", username);
                formdata.append("password", newpassword);

                var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
                redirect: 'follow'
                };

                /********calling fetch method to check user and get token***********/
                fetch(siteUrl+'/wp-json/jwt-auth/v1/token',requestOptions)
                .then((response) => response.json())
                .then(function(actualData){ 
                    console.log(actualData);

                    /******valid details and got token******/
                    if(actualData.token){
                        setResponseMessage({status:"success",message:loginSuccess});
                        actualData.login = true;
            
                        /******set token object in localstorage and state*******/
                        var requestObject = JSON.stringify(actualData);
                        localStorage.setItem('authlogin', requestObject);
                        dispatch(allActions.LoginLogoutActions.logIn(actualData));
            
                        /*******navigate to referral URL ********/
                        navigate('/');

                        /*******call login entry********/
                        callLoginEntry();
                    }else if(actualData.code==='[jwt_auth] invalid_username'){
                        setResponseMessage({status:"error",message:invalidUsername});
                    }else if(actualData.code==='[jwt_auth] incorrect_password'){
                        setResponseMessage({status:"error",message:invalidPassword});
                    }
                }).catch(rejected => {
                    setLoading(false);
                    setResponseMessage({status:"error",message:highTrafficLogin});
                });

            }
            
        }

       
       /*****click on forget password******/
       const forgetClick = () => {
           /******set message null********/
            setResponseMessage("");
           /***disable login screen***/
           setLoginScreen(false);
           /****endable forget screen*****/
           setForgetScreen(true);
       }

       /*******set screen by variable******/
       const setScreen = (data) => {
        
            setResponseMessage("");

            setLoginScreen(data==='login' ? true : false);

            setForgetScreen(data==='forget' ? true : false);

            setPasswordScreen(data==='password' ? true : false);

            setOtpScreen(data==='otp' ? true : false);

       }
       
       /*******When VIP token matched then blank screenshot and call auto login**********/
       /* if(vipToken===vipTokenString){
        return ( <></>)
        } */
      
        //|| Object.keys(LoginLogout.user).length === 0 || LoginLogout.user.login===false
        //Object.keys(LoginLogout).length === 0 this is for when first time user come
        //Object.keys(LoginLogout.user).length === 0 when user logout
        //Object.keys(LoginLogout).length === 0 || 
       if(Object.keys(LoginLogout.user).length === 0 ){

           return ( <> 
              
               {/* login box start */}
               <div className="login-main-box">
  
                    {/* container start */}
                    <div className="login-container">

                        <div className="login-logo">
                            <a target="_blank" rel="noreferrer" href="https://community.ciisummit.com/"><img src={Loginlogo} alt="" /></a>
                        </div>


                        {/* right start */}
                        <div className="login-right">

                            <div className="mobile-logo">
                            <a href="https://community.ciisummit.com/"><img src={Loginlogo} alt="logo" /></a>
                            </div>

                            <div className="login-inr-cont">

                            <div className="login-head">
                                <h2>Sign in</h2>
                                <p>Enter the email ID used to register for CIIS 2022</p>
                            </div>

                            {/* Form start */}
                            <div className="login-form">
                            <div className="custom-login-form">
                                
                                {/*********************Direct Login *********************/}
                                {loginscreen && 
                                <>
                                    <form onSubmit={loginSubmit}>

                                    <div className="form-group">
                                        <div className="user-name">
                                            <span className="icon"><i className="material-icons-outlined">person</i></span>
                                            <input type="text" className="username-control login-input" name="username" value={username} onChange={(e) => handleInputChange(e)} placeholder="Email" id="uname" required />
            
                                        </div>
                                    </div>
        
                                    <div className="form-group passformgroup direct-enter-password">
                                        <div className="user-name">
                                            <span className="icon"><i className="material-icons-outlined">password</i></span>
                                            <input type="password" className="password-direct login-input" name="password" value={password} onChange={(e) => handleInputChange(e)} placeholder="Password" required />
                                        </div>
                                    </div>
        
        
                                    <div className="rememberme form-group">
                                         <label><input name="rememberme" type="checkbox" id="rememberme" checked={rememberme} onChange={(e) => handleChechbox(e)} /> Remember Me</label>
        
                                         <button type="button"  className="forget-submit" name="forget-submit" onClick={() => forgetClick()} id="forget-submit">Set Password</button>
                                    </div>
        
                                    <div className="submit form-steps-button">
        
                                    {responsemessage && <span className={responsemessage.status}>{responsemessage.message}</span>}
        
                                    <button type="submit" id="next_login_submit" className="wide submit-login login-submit ellipsis" name="wp-submit" >
                                       {loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Login</button>
        
                                    </div>
        
                                    </form>


                                    {/* <div id="welcome_modal" className="notofication-modal-box">

                                        <div className="notofication-modal-body">
                                            <button type="button" className="modalClose" onClick={() => WelcomeCloseModal()}><span className="material-icons-outlined">close</span> Close</button>
                                            <h1>Welcome back!!</h1>
                                            <p>Please login here to confirm your registration for CIIS Webinar Series.</p>
                                            <button type="button" className="modal-btn btn" onClick={() => WelcomeCloseModal()}><span className="material-icons-outlined">login</span> Login</button>
                                        </div>

                                    </div> */}
                                    </>

                                }

                                {/***********************Forget password********************/}
                                {forgetscreen && 
                                    <form onSubmit={forgetSubmit}>

                                        <div className="form-group">
                                        <div className="user-name">
                                            <span className="icon"><i className="material-icons-outlined">person</i></span>
                                            <input type="text" className="username-control login-input" name="username" value={username} onChange={(e) => handleInputChange(e)} placeholder="Email" id="uname" required />
                                        </div>
                                        </div>


                                        <div className="submit form-steps-button">

                                        {responsemessage && <span className={responsemessage.status}>{responsemessage.message}</span>}

                                        <button type="submit" id="next_login_submit" className="wide submit-login login-submit ellipsis" name="wp-submit" > {loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Next<span class='material-icons-outlined'>navigate_next</span></button>

                                        </div>

                                        <div className="back_btn_box">
                                            <button type="button" className="back_btn" onClick={() => setScreen('login')}><span class="material-icons-outlined">chevron_left</span>Back</button>
                                        </div>

                                    </form>
                                }
                                     
                            
                                {/***********New password and confirm password screen****************/}
                                {passwordscreen &&
                                    <form onSubmit={setPasswordSubmit}>

                                    <div className="form-group">
                                        <div className="user-name">
                                            <span className="icon"><i className="material-icons-outlined">person</i></span>
                                            <input type="text" className="username-control login-input" name="username" value={username} placeholder="Email" id="uname" readOnly />
                                        </div>
                                    </div>

                                    <div className="form-group passformgroup">
                                        <div className="pass">
                                            <span className="icon">
                                            <i className="material-icons-outlined">password</i>
                                            </span>
                                            <input type="password" id="element-password" className="password-control login-input" required="" name="newpassword" value={newpassword} onChange={(e) => handleInputChange(e)} placeholder="New Password" />
                                        </div>
                                    </div>

                                    <div className="form-group confpassformgroup">
                                        <div className="pass">
                                            <span className="icon">
                                            <i className="material-icons-outlined">password</i>
                                            </span>
                                            <input type="text" id="conf-element-password" className="confirm-password-control login-input" required="" name="confirmpassword" value={confirmpassword} onChange={(e) => handleInputChange(e)} placeholder="Confirm Password" />
                                        </div>
                                    </div>
        
                                    <div className="submit form-steps-button">
        
                                    {responsemessage && <span className={responsemessage.status}>{responsemessage.message}</span>}
        
                                    <button type="submit" id="next_login_submit" className="wide submit-login login-submit ellipsis" disabled={isAnonymous ? true : false} name="wp-submit" > {loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Next<span class='material-icons-outlined'>navigate_next</span></button>
        
                                    </div>

                                    <div className="back_btn_box">
                                            <button type="button" className="back_btn" onClick={() => setScreen('forget')}><span class="material-icons-outlined">chevron_left</span>Back</button>
                                    </div>
        
                                    </form>
                                }

                                {/***********OTP screen**************/}
                                {otpscreen && 
                                      <form onSubmit={setOtpSubmit}>
                                    
                                      <div className="form-group">
                                          <div className="user-name">
                                              <span className="icon"><i className="material-icons-outlined">person</i></span>
                                              <input type="text" className="username-control login-input" name="username" value={username} placeholder="Email" id="uname" readOnly />
                                          </div>
                                      </div>
  
                                      <div className="form-group">
                                            <div className="otp">
                                                <span className="icon"><i className="material-icons-outlined">vpn_key</i></span>
                                                <input type="text" id="element-otp" className="password-otp login-input" name="otpconfirm" value={otp} onChange={(e) => handleInputChange(e)} placeholder="Enter OTP" />
                                            </div>
                                        </div>
          
                                      <div className="submit form-steps-button">
          
                                      {responsemessage && <span className={responsemessage.status}>{responsemessage.message}</span>}
          
                                      <a href="#" className="resendotp" onClick={()=> resendOTP()} >{butttontext ? "Resend OTP" : "Please wait.."}</a>

                                      <button type="submit" id="next_login_submit" className="wide submit-login login-submit ellipsis" name="wp-submit" >{loading && <span className="material-icons-outlined spin">motion_photos_on</span>} Submit</button>
          
                                      </div>
          
                                      {/* <div className="back_btn_box">
                                            <button type="button" className="back_btn" onClick={() => setScreen('password')}><span class="material-icons-outlined">chevron_left</span>Back</button>
                                      </div> */}

                                      </form>
                                }

                            
                            </div>
                            </div>
                            {/* Form end */}

                            </div>

                            <LoginRightBottom />

                          

                        </div>
                        {/* right end */}

                        {/* copyright bar */}
                        <Copyright />


                    </div>
                    {/* container end */}

                    
                 </div>
                    {/* login box end */}

                     {/* background video start */}
                    <div className="login-background-box">
                    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice">
                    <defs>
                    <radialGradient id="Gradient1" cx="50%" cy="50%" fx="0.441602%" fy="50%" r=".5">
                        <animate attributeName="fx" dur="34s" values="0%;3%;0%" repeatCount="indefinite"></animate>
                        <stop offset="0%" stopColor="rgba(0, 19, 68, 1)"></stop>
                        <stop offset="100%" stopColor="rgba(0, 19, 68, 0)"></stop>
                    </radialGradient>

                    <radialGradient id="Gradient2" cx="50%" cy="50%" fx="2.68147%" fy="50%" r=".5">
                        <animate attributeName="fx" dur="23.5s" values="0%;3%;0%" repeatCount="indefinite"></animate>
                        <stop offset="0%" stopColor="rgba(8, 57, 104, 1)"></stop>
                        <stop offset="100%" stopColor="rgba(8, 57, 104, 0)"></stop>
                    </radialGradient>

                    <radialGradient id="Gradient3" cx="50%" cy="50%" fx="0.836536%" fy="50%" r=".5">
                        <animate attributeName="fx" dur="21.5s" values="0%;3%;0%" repeatCount="indefinite"></animate>
                        <stop offset="0%" stopColor="rgba(3, 12, 36, 1)"></stop>
                        <stop offset="100%" stopColor="rgba(3, 12, 36, 0)"></stop>
                    </radialGradient>

                    <radialGradient id="Gradient4" cx="50%" cy="50%" fx="4.56417%" fy="50%" r=".5">
                        <animate attributeName="fx" dur="23s" values="0%;5%;0%" repeatCount="indefinite"></animate>
                        <stop offset="0%" stopColor="rgb(8, 57, 104)"></stop>
                        <stop offset="100%" stopColor="rgba(8, 57, 104, 0)"></stop>
                    </radialGradient>

                    <radialGradient id="Gradient5" cx="50%" cy="50%" fx="2.65405%" fy="50%" r=".5">
                        <animate attributeName="fx" dur="24.5s" values="0%;5%;0%" repeatCount="indefinite"></animate>
                        <stop offset="0%" stopColor="rgba(3, 12, 36, 1)"></stop>
                        <stop offset="100%" stopColor="rgba(3, 12, 36, 0)"></stop>
                    </radialGradient>

                    <radialGradient id="Gradient6" cx="50%" cy="50%" fx="0.981338%" fy="50%" r=".5">
                        <animate attributeName="fx" dur="25.5s" values="0%;5%;0%" repeatCount="indefinite"></animate>
                        <stop offset="0%" stopColor="rgb(0, 19, 68)"></stop>
                        <stop offset="100%" stopColor="rgba(0, 19, 68, 0)"></stop>
                    </radialGradient>
                    </defs>
                    
                    <rect x="13.744%" y="1.18473%" width="100%" height="100%" fill="url(#Gradient1)" transform="rotate(334.41 50 50)">
                        <animate attributeName="x" dur="20s" values="25%;0%;25%" repeatCount="indefinite"></animate>
                        <animate attributeName="y" dur="21s" values="0%;25%;0%" repeatCount="indefinite"></animate>
                        <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="20s" repeatCount="indefinite"></animateTransform>
                    </rect>
                    <rect x="-2.17916%" y="35.4267%" width="100%" height="100%" fill="url(#Gradient2)" transform="rotate(255.072 50 50)">
                        <animate attributeName="x" dur="23s" values="-25%;0%;-25%" repeatCount="indefinite"></animate>
                        <animate attributeName="y" dur="24s" values="0%;50%;0%" repeatCount="indefinite"></animate>
                        <animateTransform attributeName="transform" type="rotate" from="0 50 50" to="360 50 50" dur="28s" repeatCount="indefinite"></animateTransform>
                    </rect>
                    <rect x="9.00483%" y="14.5733%" width="100%" height="100%" fill="url(#Gradient3)" transform="rotate(139.903 50 50)">
                        <animate attributeName="x" dur="25s" values="0%;25%;0%" repeatCount="indefinite"></animate>
                        <animate attributeName="y" dur="12s" values="0%;25%;0%" repeatCount="indefinite"></animate>
                        <animateTransform attributeName="transform" type="rotate" from="360 50 50" to="0 50 50" dur="24s" repeatCount="indefinite"></animateTransform>
                    </rect>
                    </svg>
                    </div>
                    {/* background video end */}
                  
        </> ) }
        
       /*********If user Loggedin********/
       if(LoginLogout.user.login===true){
                  
            return ( <>   

                <div className="login-main-box">
    
                        {/* container start */}
                        <div className="login-container"> 

                                <div className="login-logo">
                                        <a target="_blank" rel="noreferrer" href="https://ciisummit.com/"><img src={Loginlogo} alt="" /></a>
                                </div>


                                {/* right start */}
                                <div className="login-right after-login">

                                    <div className="mobile-logo">
                                        <a href="https://ciisummit.com"><img src={Loginlogo} alt="logo" /></a>
                                    </div>
                        
                                    <h1>Hello, {LoginLogout.user.user_display_name}</h1>

                                    <NavLink exact="true" className="back-to-home" to="/"><span className="material-icons-outlined">home</span> Back to Home</NavLink>

                                
                                    {/**********If token expired************/}
                                    {!storageDataAuthLogin && <h2>Token Expired, Please Login Again</h2>}

                                    {queryParams.get("message") && <h2>{queryParams.get("message")}</h2>}
                                    
                                    {/* <Logout layout="menu"/> */}
                                </div>
                        </div>
                    </div>
                </> 

            ) 
        
        }
}

export default Login;
